'use client'

import { Fragment } from 'react'
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react'
import { X } from 'lucide-react'
import ProfileCard from './ProfileCard'

export default function ProfileDrawer({ open, onClose, vendor, customer, isLoading, setIsLoading }: { open: boolean, onClose: () => void, vendor: any, customer: any, isLoading: boolean, setIsLoading: (loading: boolean) => void }) {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <TransitionChild as={Fragment} enter="transition-opacity ease-linear duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity ease-linear duration-300" leaveFrom="opacity-100" leaveTo="opacity-0">
          <div className="fixed inset-0 bg-black/60" />
        </TransitionChild>
        <div className="fixed inset-0 z-50 flex justify-end">
          <TransitionChild as={Fragment} enter="transition ease-in-out duration-300 transform" enterFrom="translate-x-full" enterTo="translate-x-0" leave="transition ease-in-out duration-300 transform" leaveFrom="translate-x-0" leaveTo="translate-x-full">
            <DialogPanel className="relative flex w-[86%] max-w-sm flex-col overflow-hidden shadow-2xl rounded-l-2xl" style={{ background: '#0b0b0e' }}>
              <div className="h-14 px-5 flex items-center justify-between shrink-0" style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
                <DialogTitle className="text-[15px] font-semibold text-white" style={{ fontFamily: 'Gilroy, Inter, sans-serif' }}>
                  Профайл
                </DialogTitle>
                <button onClick={onClose} aria-label="Хаах" className="w-9 h-9 inline-flex items-center justify-center rounded-full transition-colors hover:bg-white/5" style={{ color: 'rgba(255,255,255,0.6)' }}>
                  <X className="h-5 w-5" />
                </button>
              </div>
              <div className="flex-1 overflow-y-auto overscroll-contain scrollbar-dark">
                <ProfileCard customer={customer} isLoading={isLoading} setIsLoading={setIsLoading} vendor={vendor} onLinkClick={onClose} />
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  )
}
